export const por = {
  _LOGIN: {
    _EMAIL: "Email",
    _PASSWORD: "Senha",
    _REMEMBER: "Lembrar-me",
    _LOGIN: "ENTRAR",
    _SIGNUP: "Cadastre-se",
    _FORGOTPASSWORD: "Esqueceu a senha?",
    _NOACCOUNT: "Não tem uma conta?",
    _ERROR_EMAIL: "Parece que você não está registrado! Tente novamente.",
    _ERROR_PASSWORD: "Senha incorreta",
    _SUCCESS: "Login bem-sucedido",
  },
  _REGISTER: {
    _REGISTER: "Registrar conta",
    _NAME: "Nome de usuário",
    _EMAIL: "Seu email",
    _PASSWORD: "Sua senha",
    _CONFIRMPASSWORD: "Confirmar senha",
    _WHATSAPP: "WhatsApp",
    _TELEGRAM: "Telegram (opcional)",
    _HAVEACCOUNT: "Já tenho uma conta",
    _ERROR_REFERAL: "Código de convite errado",
    _ERROR_EMAIL: "Este email já existe",
    _SUCCESS: "Cadastro bem-sucedido",
  },
  _SIDEBAR: {
    _PAGES: "Páginas",
    _OPEN: "Abrir barra lateral",
    _DASHBOARD: "Início",
    _NETWORK: "Rede",
    _FINANCE: "Carteira",
    _PACKAGES: "Planos",
    _SIGNOUT: "Sair",
    _LANGUAGE: "Idioma",
    _PROFILE: "Perfil",
    _AUTH: "Autenticador",
  },
  _DASHBOARD: {
    _TITLE: "Saldo",
    _TITLE2: "Depósito",
    _TITLE3: "Ganhos Totais",
    _TITLE4: "Ganhos Unilevel",
    _TITLE5: "Bônus de Correspondência Infinita",
    _TITLE6: "Plano",
    _TITLE7: "Bônus de Início Unilevel",
    _TITLE8: "Bônus Binário",
    _TITLE9: "Bônus de Correspondência Binária",
    _TITLE10: "Bônus Residual do COPY TRADING",
    _TOTAL: "Total",
    _TABLE3: "Lista de Pacotes",
    _START: "Iniciar",
    _FINISH: "Finalizar",
    _STATUS: "Status",
    _STATUS_ACTIVE: "Ativo",
    _STATUS_INACTIVE: "Inativo",
    _CURRENT: "Atual",
    _UPGRADE: "Atualizar",
    _COPYMESSAGE: "Cópia bem-sucedida",
    _NOTIFICATION1: "Novo Depósito",
    _NOTIFICATION2: "Lucro Cryptotradex",
    _NOTIFICATION3: "Lucro Unilevel",
    _NOTIFICATION4: "Faixa Infinita",
    _NOTIFICATION5: "Compra de Pacote",
    _NOTIFICATION7: "Bônus Recorrente de Referido Direto",
    _PREV: "Anterior",
    _NEXT: "Próximo",
    _TABLE4_A: "Operação",
    _TABLE4_B: "Lucro",
    _TABLE4_C: "ROI",
    _TABLE4_D: "Data",
    _SHARED: "Compartilhe seu link de referido",
    _TITLESHARED: "Link de referido",
    _TEXTSHARED:
      "Compartilhe seu link de referido binário e escolha a posição onde deseja colocar seu convidado, ou deixe que seja atribuído aleatoriamente.",
    _RANDOM: "Aleatório",
    _CTFLIX:
      "Capacite-se nos modelos de negócio em alta e de alta rentabilidade com Web3.",
    _SIGNAL:
      "Obtenha os melhores sinais em um só lugar e multiplique seu capital.",
    _COPY:
      "Esqueça de acompanhar entradas e saídas — copie todas as operações com um clique.",
    _CTXII:
      "Multiplique seu capital por 12 automaticamente em parceria com a CTX. Entre em contato com quem lhe apresentou esta oportunidade.",
    _ENTER: "Entrar",
    _INPOSITION: "Fase de Posicionamento",
  },
  _FINANCE: {
    _DEPOSIT: "Depósito",
    _QR: "Escaneie o seguinte QR ou copie o endereço",
    _NETWORK: "Rede",
    _INSTRUCTIONS: "Instruções para Enviar SOLANA (SOL)",
    _STEP1: "Certifique-se de que a rede selecionada seja SOLANA.",
    _STEP2:
      "Envie a quantidade de SOLANA para o seguinte endereço de carteira.",
    _COPY: "Copiar",
    _DISCLAIMER:
      "Aviso legal: Não somos responsáveis por transações feitas fora da rede SOLANA ou pelo envio de criptomoedas que não sejam SOLANA. Qualquer perda de fundos devido a esses erros será de responsabilidade exclusiva do remetente.",
    _TABLE1: "Histórico de Depósitos",
    _TABLE1_A: "Pedido",
    _TABLE1_B: "Valor",
    _TABLE1_C: "Data",
    _TABLE1_D: "Status",
    _SUCCESS: "O pacote foi adicionado com sucesso",
    _COPYMESSAGE: "Endereço da carteira copiado com sucesso",
  },
  _PACKAGES: {
    _ATTENTION:
      "Atenção: Você tem uma conta corporativa. Ao comprar um pacote, você reiniciará a conta e todos os seus benefícios.",
    _PACKAGES: "Selecione o melhor plano para você",
    _SUBTITLE: "Você tem 8 opções",
    _BALANCE: "Depósito de saldo",
    _PACKAGE: "Pacote ",
    _PACKAGE_1: "Você ganhará até o nível ",
    _PACKAGE_2: "Ganhe até",
    _PACKAGE_3: "ROI semanal",
    _BUTTON1: "Preenchido",
    _BUTTON2: "Comprar",
    _CALCULATE: "Calcular plano",
    _RECHARGE: "Você não tem saldo suficiente, recarregue sua carteira",
    _PACKAGEMESSAGE: "Você deve comprar um pacote maior",
    _SUCCESS: "O pacote foi adicionado com sucesso",
    _UPDATE: "Preço de atualização do pacote",
    _BASIC: "Básico",
    _INTERMEDIATE: "Básico + Intermediário",
    _ADVANCED: "Básico + Intermediário + Avançado",
    _COMPLETED: "Concluído",
    _SIGNALS: "Sinais CTX",
    _COPY: "CopyTrading CTX",
  },
  _NETWORK: {
    _TODAY: "Hoje",
    _AVAILABLE: "Disponível",
    _WITHDRAW: "Total Retirado",
    _SEARCHLABEL: "Pesquisa por email",
    _SEARCH: "Pesquisar",
    _NETWORK: "Rede",
    _DIRECTS: "Referidos diretos",
    _SUCCESS: "Pesquisa bem-sucedida",
    _ERROR: "Não faz parte da sua árvore.",
    _LEVEL: "Nível",
    _USERS: "Usuários",
    _AMOUNT: "Valor",
    _USERNAME: "Nome de usuário",
    _EMAIL: "Email",
    _WHATSAPP: "WhatsApp",
    _PACKAGE: "Pacote",
    _LEFT: "Esquerda",
    _RIGHT: "Direita",
    _TOTALLEFT: "Cumulative Total Left",
    _TOTALRIGHT: "Cumulative Total Right",
    _BINARYTEXT:
      "Para colocar seu referido na árvore binária, pressione e segure o botão correspondente (esquerda ou direita). Lembre-se de que essa ação só pode ser feita uma vez, então recomendamos revisar cuidadosamente sua seleção antes de confirmar.",
    _BINARYSUCCESS: "Transação concluída com sucesso",
    _BINARYLOADING: "Carregando...",
    _SEARCHFORUSERNAME: "Pesquisar por nome de usuário",
    _TANK: "Tanque de referidos diretos",
  },
  _PROFILE: {
    _TITLE: "Perfil",
    _NAME: "Seu nome",
    _EMAIL: "Seu email",
    _WHATSAPP: "WhatsApp",
    _CURRENTPASSWORD: "Senha atual",
    _PASSWORD: "Nova senha",
    _CONFIRMPASSWORD: "Confirmar nova senha",
    _WALLET: "Endereço de retirada",
    _ACTION: "Editar",
    _TIPS: "Dicas",
    _TIPS_1: "O nome deve ser legível e não pode ultrapassar 20 caracteres.",
    _TIPS_2:
      "A senha deve incluir números, letras e símbolos; quanto mais complexa, melhor.",
    _TIPS_3:
      "O email não pode ser alterado. Se precisar fazer uma alteração, entre em contato com o suporte.",
    _TIPS_4:
      "O endereço de retirada só pode ser modificado com um autenticador de 2 fatores, que deve ser ativado previamente.",
    _ERROR_PASSWORD: "Erro na senha anterior",
    _SUCCESS: "Perfil atualizado com sucesso",
    _MIN: "Retirada mínima",
    _UPDATE: "Atualizar perfil",
  },
  _RECOVERPASSWORD: {
    _RECOVERPASSWORD: "Esqueceu a senha?",
    _EMAIL: "Seu email",
    _BUTTON: "Enviar email",
    _MESSAGE: "Sua senha foi enviada para seu email",
    _ERROR_EMAIL: "Este email não está registrado",
  },
  _GLOBALV: {
    _TITLE: "GV",
    _CURRENT: "Rank atual",
    _NEXT: "Próximo rank",
    _SILVER: "Prata",
    _GOLD: "Ouro",
    _RUBY: "Rubi",
    _EMERALD: "Esmeralda",
    _DIAMOND: "Diamante",
    _DIAMONDB: "Diamante Azul",
    _DIAMONDBB: "Diamante Preto",
    _NONE: "Nenhum",
  },
  _AUTH: {
    _TITLEDEFAULT: "Alterar endereço de retirada",
    _TITLE: "Passo 1",
    _TITLE2: "Passo 2",
    _TITLE3: "Passo 3",
    _STEP1: "Baixe e instale o autenticador em seu dispositivo",
    _STEP2: "Escaneie o código para salvar",
    _FORMEMAIL: "Verificação de email",
    _FORMHELPEMAIL: "Digite o código de verificação de 6 dígitos enviado para",
    _FORMHELPAUTH: "Digite o código de 6 dígitos gerado pelo App Autenticador",
    _FORM1: "Pin pelo Autenticador",
    _FORM2: "Endereço de retirada",
    _FORMMIN: "O endereço de retirada deve ter 34 caracteres",
    _FORMCODESEND: "Código enviado",
    _VERIFF: "Veriff",
    _ACTION: "Verificar e salvar",
    _ERROR: "Erro, tente novamente.",
    _SUCCESS: "Alteração bem-sucedida",
    _RETRYOTP: "Erro ao enviar o código, tente novamente.",
    _SENDOTP: "Código enviado com sucesso",
    _SUCCESSOTP: "OTP verificado com sucesso",
    _SUCCESSAUTH2F: "Autenticação 2FA verificada com sucesso",
    _ERRORCODE: "Código inválido, tente novamente",
  },
  _COUNTDOWN: {
    _TITLE: "Próximo corte:",
    _DAYS: "Dias",
    _HOURS: "Horas",
    _MINUTES: "Minutos",
    _SECONDS: "Segundos",
  },
  _WITHDRAWAL: {
    _TITLE: "Transações de Retirada",
    _ERRORPROCESS:
      "Você já tem outra retirada em processo, aguarde alguns minutos",
    _ERRORWALLET:
      "Você deve primeiro configurar sua carteira de retirada Solana",
    _ERRORBALANCE: "O saldo negativo é reiniciado novamente.",
    _ERROROTHER: "Erro ao realizar a retirada, por favor, tente novamente.",
    _SUCCESS: "Retirada bem-sucedida. Chegará na sua carteira em minutos.",
  },
  _SYSTEM: {
    _SYSTEM: "Sistema",
    _GLOBAL: "Global",
    _INVESTMENT: "Retirar investimento",
    _INVESTMENTTEXT:
      "Lembre-se de que haverá uma penalidade de 35% do seu investimento",
    _ACCELERATE: "Acelerar",
    _REPORT: "Relatório de investimento Cryptotradex",
    _PARNERT: "Informações do patrocinador",
  },
  _WITHDRAWINVESTMENT: {
    _TITLE: "Retirar investimento",
    _MESSAGE:
      "Retirar seu capital agora envolve uma taxa operacional de 35% sobre seu investimento - ganhos acumulados, e será processado dentro de 24 horas. Se fizer isso, interromperá o potencial de crescimento imediato. Decida com uma visão de longo prazo!",
    _BUTTON: "Retirar",
    _BUTTONWAIT: "Retirada em processo",
  },
  _SIGNAL: {
    _NEWS: "Novo",
    _SIGNALS: "Sinais",
    _CHAT: "Chat exclusivo",
    _OPEN: "Aberto",
    _CLOSED: "Fechado",
    _PRICEENTRY: "Preço de entrada",
    _PRICEEND: "Preço de fechamento",
    _INITIAL: "Preço inicial",
    _MAXIMUN: "Preço máximo ATH",
    _DATEATH: "Data ATH",
    _MKCAP: "Vl Mercado",
  },
  _ACADEMY: {
    _NEWS: "Novo",
    _TITLE: "Academia",
    _WHATIS: "O que é Cryptotradex Academy?",
    _DESCRIPTION:
      "Aprenda sobre criptomoedas, carteiras, memes e Web3 com nossa plataforma online projetada para todos os níveis.",
    _ACTION1: "Ir para a Academia",
    _DISABLED: "É necessário um depósito mínimo de 500 USD",
    _TITLANDING: "Torne-se um especialista em Cryptomemes",
    _DESCRIPTIONLANDING:
      "Acesse tutoriais exclusivos do pacote BRETT e aprenda a dominar o mundo dos MEMECOINS.",
    _ACTIONLANDING: "Inscreva-se agora e comece a aprender!",
    _WHATCOURSES: "Quais cursos você receberá?",
    _RECOMMENDS: "Vídeos recomendados",
  },
  _FREE: {
    _FREE: "Grátis",
    _FREEFOR: "GRÁTIS POR UM LONGO TEMPO",
    _SIGNALS: "Ir para os sinais",
    _LINK: "Link da comunidade",
    _TITLE:
      "Junte-se à nossa comunidade do WhatsApp para obter informações imediatas e em tempo real",
    _DISCLAIMER: "Aviso legal",
    _CHANNEL: "Ir para o canal",
    _TEXTDISCLAIMER:
      "Esses sinais têm um período de execução, no momento em que os publicamos no nosso grupo de sinais é quando alcançamos o lucro demonstrado.",
    _LEGEND: "Legenda",
    _NAME: "Nome do token",
    _URL: "Link do DexScrenner",
    _START: "Hora de início",
    _END: "Hora de término",
    _PROFIT: "Lucro",
    _VER: "Ir",
  },
  _CTFLIX: {
    _BASIC: "Básico",
    _INTERMEDIATE: "Intermediário",
    _ADVANCED: "Avançado",
    _MODULE0: "Módulo Inicial",
    _MODULE1: "Módulo 1 Segurança em criptomoedas",
    _MODULE2: "Módulo 2 Coinbase",
    _MODULE3: "Módulo 3 Bybit",
    _MODULE4: "Módulo 4 Binance",
    _MODULE5: "Módulo 5 Exchanges",
    _MODULE6: "Módulo 6 Ferramentas Básicas",
    _MODULE7: "Módulo 7 Rabby Wallet",
    _MODULE8: "Módulo 8 Phantom Wallet",
    _MODULE9: "Módulo 9 Trezor",
    _MODULE10: "Módulo 10 Ledger",
    _MODULE11: "Módulo 11 Ferramentas Onchain",
    _MODULE12: "Módulo 12 Análise OnChain",
    _MODULE13: "Módulo 13 GMGN",
    _MODULE14: "Módulo 14 Dexscreener Avançado",
    _MODULE15: "Módulo 15 Bot Bull x NEO",
    _ALLLANGUAGE: "Todos os idiomas",
    _ALLTYPES: "Todos os tipos",
    _ALLLMODULES: "Todos os módulos",
    _REQUIREDBASIC:
      "Atualize seu pacote e acesse módulos exclusivos como: Segurança em Crypto, Coinbase, Bybit, Binance, e mais de 54 vídeos educacionais!",
    _REQUIREDINTERMEDIATE:
      "Não deixe faltar módulos essenciais como: Exchanges, Ferramentas Básicas, e o uso de Wallets como Rabby Wallet, Phantom, Trezor e Ledger! Atualize seu pacote e mantenha acesso a todo o conteúdo.",
    _REQUIREDADVANCED:
      "Não perca o acesso a ferramentas avançadas como: Análise Onchain, GMGN, DexScreener e aprenda a usar o Bot Bull Neo! Atualize seu pacote para explorar todo o potencial dessas plataformas.",
  },
  _COPY: {
    _TITLE: "Minha Carteira de Copy Trading",
    _MIN: "Depósito mínimo 300 USD",
    _BALANCE: "Saldo",
    _TYPE: "Tipo",
    _CONSERVE: "Conservador",
    _CONSERVEDESCRIPTION: "Baixo risco, estabilidade e preservação de capital.",
    _MODERADE: "Moderado",
    _MODERADEDESCRIPTION: "Equilíbrio entre risco e crescimento.",
    _ADVANCED: "Arriscado",
    _ADVANCEDDESCRIPTION:
      "Alto risco, altos retornos potenciais, alta volatilidade.",
    _SLIPPAGE: "Deslizamento",
    _SUPPLY: "Montante a operar",
    _TIME: "Tempo",
    _STATISTICS: "Estatísticas",
    _DISCLAIMER:
      "Para ativar o sistema de copy trading, é necessário realizar um depósito inicial no valor mínimo de <strong class='text-red-300'>300 USD</strong>. Após essa etapa, o sistema passará por um processo de configuração que pode levar de 24 a 72 horas úteis. <br/> <br/> Após esse processo, o sistema começará a operar em tempo real, replicando as estratégias da nossa equipe de traders. <br/> <br/> É importante destacar que não somos obrigados a realizar operações todos os dias. Executamos operações apenas quando o mercado apresenta condições favoráveis, evitando riscos desnecessários. <br/> <br/> Este sistema não garante retornos constantes. Os usuários aceitam que ganhos e perdas fazem parte natural do comportamento do mercado, que é livre e não manipulado. Em caso de perdas, não serão aceitas reclamações. <br/> <br/> No entanto, temos profundo orgulho do nosso conhecimento e experiência, e agimos com responsabilidade em cada decisão tomada. <br/> <br/> Por fim, todo o processo de copy trading inclui uma etapa de configuração e verificação manual, na qual os dados do usuário e as informações do sistema são validados antes da ativação.",
    _ACTION: "Ações",
    _PORTFOLIO: "Portfólio",
    _CAPITAL: "Retirar Capital",
    _EARNINGS: "Retirar Ganhos",
    _CONNECTION: "Conexão",
  },
  _NOTICE: {
    _NOTICE: "Aviso Estelar",
    _CRYPTOCARD: "CryptoCard está chegando",
    _DESCRIPTION: "Nosso cartão, prepare-se para uma experiência completa.",
    _NEW: "Novo membro?",
    _DISCOVERY: "Descubra tudo o que temos para",
    _YOU: "você",
    _MYBUSINESS: "Meu negócio",
    _MYPRODUCTS: "Meus produtos",
  },
  _STATISTICS: {
    _FROM: "De",
    _UNTIL: "Até",
    _NUMBERSOPERATIONS: "Número de transações",
  },
};
